import { render } from "./ViewUblDetail.vue?vue&type=template&id=3c666cd0&scoped=true"
import script from "./ViewUblDetail.vue?vue&type=script&lang=js"
export * from "./ViewUblDetail.vue?vue&type=script&lang=js"

import "./ViewUblDetail.vue?vue&type=style&index=0&id=3c666cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c666cd0"]])

export default __exports__